import { Label, Rank } from '../enums';
import { Card, Entry } from '../types';
import { getHighCardRanks, getRankCounts, getRankIndex } from './helpers';

const FRONT_HAND_TYPE_VALUES: Record<string, number> = {
  [Label.FRONT_HIGH_CARD]: 0,
  [Label.FRONT_ONE_PAIR]: 1,
  [Label.FRONT_THREE_OF_A_KIND]: 2,
};

function buildFrontIndex(handType: Label, kickers: Rank[]): number {
  let index = FRONT_HAND_TYPE_VALUES[handType] * 2197;
  for (let i = 0; i < kickers.length; i++) {
    index += getRankIndex(kickers[i]) * Math.pow(13, 2 - i);
  }
  return index;
}

export function evaluateFrontHand(cards: readonly Card[]): Entry {
  if (cards.length !== 3) {
    throw new Error(`Front hand requires exactly 3 cards, got ${cards.length}`);
  }

  const rankCounts = getRankCounts(cards);

  const counts = Array.from(rankCounts.entries()).sort((a, b) => {
    if (b[1] !== a[1]) return b[1] - a[1];
    return getRankIndex(b[0]) - getRankIndex(a[0]);
  });

  if (counts[0][1] === 3) {
    const trips = counts[0][0];
    return {
      label: Label.FRONT_THREE_OF_A_KIND,
      index: buildFrontIndex(Label.FRONT_THREE_OF_A_KIND, [trips]),
    };
  }

  if (counts[0][1] === 2) {
    const pair = counts[0][0];
    const kicker = counts[1][0];
    return {
      label: Label.FRONT_ONE_PAIR,
      index: buildFrontIndex(Label.FRONT_ONE_PAIR, [pair, kicker]),
    };
  }

  const kickers = getHighCardRanks(cards);
  return {
    label: Label.FRONT_HIGH_CARD,
    index: buildFrontIndex(Label.FRONT_HIGH_CARD, kickers),
  };
}
